var scope_0 = require('/home/runner/work/stjude.cloud/stjude.cloud/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/168edc7dea1d260750c3a48633d608ea.js').default;
var scope_1 = require('/home/runner/work/stjude.cloud/stjude.cloud/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54b47f07b5193704e79366b8df8eb1d5.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    